import apiSlice from "./ApiSlice";

export const expenseCategoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL
    getAllExpenseCategory: builder.query({
      providesTags: ["expense-category"],
      query: () => {
        return {
          url: "/expense-category",
          method: "GET",
        };
      },
    }),

    // GET
    getExpenseCategory: builder.query({
      providesTags: ["expense-category"],
      query: (body) => {
        return {
          url: "/expense-category/",
          method: "POST",
          body,
        };
      },
    }),
    // ADD
    addExpenseCategory: builder.mutation({
      invalidatesTags: ["expense-category"],
      query: (body) => {
        return {
          url: "/expense-category/add",
          method: "POST",
          body,
        };
      },
    }),
    // DELETE
    deleteExpenseCategory: builder.mutation({
      invalidatesTags: ["expense-category"],
      query: ({ id }) => {
        return {
          url: `/expense-category/${id}`,
          method: "DELETE",
        };
      },
    }),
    // GET CATEGORY BY ID
    getExpenseCategoryById: builder.query({
      providesTags: ["expense-category"],
      query: ({ id }) => {
        return {
          url: `/expense-category/${id}`,
          method: "GET",
        };
      },
    }),
    // EDIT
    editExpenseCategory: builder.mutation({
      invalidatesTags: ["expense-category"],
      query: ({ body, id }) => {
        return {
          url: `/expense-category/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useGetAllExpenseCategoryQuery,
  useGetExpenseCategoryQuery,
  useAddExpenseCategoryMutation,
  useDeleteExpenseCategoryMutation,
  useGetExpenseCategoryByIdQuery,
  useEditExpenseCategoryMutation,
} = expenseCategoryApi;
